<template>
      <v-form ref="formPlannedContacts" v-model="formPlannedContacts">
        <p class="text-h5">{{ languageData.section.plannedContacts }}</p>
        <v-textarea
            class="mt-5"
            outlined
            :rules="rules.description"
            :label="languageData.plannedContacts.description"
            v-model="plannedContact.description"
            rows="6">
        </v-textarea>
        <div class="mb-2">
          {{ languageData.plannedContacts.plannedAt }}
        </div>
        <div class="row justify-center">
          <div class="col-6">
            <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="plannedDate"
                    :label="'Date'"
                    :rules="rules.plannedAt"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    rows="3"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="plannedDate"
                  no-title
                  scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="menu1 = false"
                >
                  {{ languageData.cancel }}
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="$refs.menu1.save(plannedDate)"
                >
                  {{ languageData.btnAgreeText }}
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <div class="col-6">
            <v-menu
                ref="menu"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="plannedTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :rules="rules.plannedAt"
                    v-model="plannedTime"
                    label="Time"
                    outlined
                    prepend-inner-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                  v-if="menu2"
                  format="24hr"
                  v-model="plannedTime"
                  full-width
                  @click:minute="$refs.menu.save(plannedTime)"
              ></v-time-picker>
            </v-menu>
          </div>
        </div>
        <v-btn color="primary"
               @click="addPlannedContact"
               :loading="dataSaveIsFetching"
        >
          {{ languageData.saveBtn }}
        </v-btn>
        <ModalInfo
            :typeInfo="typeInfoPlannedContactSave"
            :headModal="headInfoPlannedContactSave"
            :btnAgreeText="languageData.btnAgreeText"
            :visDisAgreeBtn="false"
            @clicked="hidePlannedContactModal"
            :show-modal="isPlannedContactSave"
            :text-modal="textInfoPlannedContactSave">
        </ModalInfo>
      </v-form>
</template>


<script type="text/javascript">

import { mapActions, mapState } from "vuex";
import eventBus from "../../../event-bus/eventBus";
import handleFormError from "../../../helpers/handleFormError";
import ModalInfo from "../../../components/ModalInfo/ModalInfo";

export default {
  name: "PlannedContactForm",
  props: {
    contactableType: String,
    layout: String
  },
  components: {
    ModalInfo
  },
  data() {
    return {
      plannedDate: '',
      plannedTime: '',
      plannedContact: {
        description: '',
        plannedAt: '',
        isSuccessful: null,
        projectId: null,
      },
      formPlannedContacts: false,
      validForm: false,
      rules: {},
      menu1: false,
      menu2: false
    }
  },
  computed: {
    ...mapState("savePlannedContact", {
      dataSaveIsFetching: state => state.dataSaveIsFetching,
      textInfoPlannedContactSave: state => state.textInfoPlannedContactSave,
      typeInfoPlannedContactSave: state => state.typeInfoPlannedContactSave,
      headInfoPlannedContactSave: state => state.headInfoPlannedContactSave,
      isPlannedContactSave: state => state.isPlannedContactSave,
    }),
    ...mapState("getProjectsClient", {
      projectClients: state => state.dataReceive
    }),
    ...mapState("getPlannedContacts", {
      chosenClient: state => state.chosenClient
    })
  },
  methods: {
    ...mapActions("savePlannedContact", ["storePlannedContact", "updateVisibleModalPlannedContact"]),
    ...mapActions("getProjectsClient", ["getProjectsClient"]),

    addPlannedContact: function() {
      let data = this.plannedContact;
      data.contactableType = this.contactableType;
      data.plannedAt = this.plannedDate + ' ' + this.plannedTime;
      data.layout = this.layout;
      data.chosenClient = this.chosenClient
      this.rules = {};
      this.$refs.formPlannedContacts.resetValidation();
      this.storePlannedContact({ creds: { data } });
    },
    hidePlannedContactModal() {
      this.updateVisibleModalPlannedContact(false);
    },
    clearSelect() {
      this.plannedContact.projectId = null;
    }
  },
  mounted() {
    if(this.layout !== 'project') {
      this.getProjectsClient();
    }
    eventBus.$on("savePlannedContactSuccess", () => {
      this.plannedContact = {
        description: '',
        plannedAt: '',
        isSuccessful: null,
      }
      this.plannedDate = '';
      this.plannedTime = '';
    });
    eventBus.$on("savePlannedContactFailure", (errorsReceive) => {
      this.rules = handleFormError(errorsReceive);
      this.validForm = this.$refs.formPlannedContacts.validate();
    });
  }
}
</script>